export const STATUS_TRANSLATION_MAP = {
  Destroyed: 'DataErasureCard_Destroyed',
  Erased: 'DataErasureCard_Erased',
} as const
